__turbopack_context__.v({
  "alignBaseline": "Flex-module-scss-module__lgIY7G__alignBaseline",
  "alignCenter": "Flex-module-scss-module__lgIY7G__alignCenter",
  "alignEnd": "Flex-module-scss-module__lgIY7G__alignEnd",
  "alignStart": "Flex-module-scss-module__lgIY7G__alignStart",
  "alignStretch": "Flex-module-scss-module__lgIY7G__alignStretch",
  "center": "Flex-module-scss-module__lgIY7G__center",
  "column": "Flex-module-scss-module__lgIY7G__column",
  "columnReverse": "Flex-module-scss-module__lgIY7G__columnReverse",
  "contentCenter": "Flex-module-scss-module__lgIY7G__contentCenter",
  "contentEnd": "Flex-module-scss-module__lgIY7G__contentEnd",
  "contentSpaceAround": "Flex-module-scss-module__lgIY7G__contentSpaceAround",
  "contentSpaceBetween": "Flex-module-scss-module__lgIY7G__contentSpaceBetween",
  "contentStart": "Flex-module-scss-module__lgIY7G__contentStart",
  "contentStretch": "Flex-module-scss-module__lgIY7G__contentStretch",
  "flex": "Flex-module-scss-module__lgIY7G__flex",
  "full": "Flex-module-scss-module__lgIY7G__full",
  "inline": "Flex-module-scss-module__lgIY7G__inline",
  "justifyAround": "Flex-module-scss-module__lgIY7G__justifyAround",
  "justifyBetween": "Flex-module-scss-module__lgIY7G__justifyBetween",
  "justifyCenter": "Flex-module-scss-module__lgIY7G__justifyCenter",
  "justifyEnd": "Flex-module-scss-module__lgIY7G__justifyEnd",
  "justifyStart": "Flex-module-scss-module__lgIY7G__justifyStart",
  "nowrap": "Flex-module-scss-module__lgIY7G__nowrap",
  "row": "Flex-module-scss-module__lgIY7G__row",
  "rowReverse": "Flex-module-scss-module__lgIY7G__rowReverse",
  "wrap": "Flex-module-scss-module__lgIY7G__wrap",
  "wrapReverse": "Flex-module-scss-module__lgIY7G__wrapReverse",
});
